import cardValidator from '@ott/utility-card-validator';

const notANumberRegExp = /\D/;

/**
 * Получение данных карты
 * @param cardNumber
 * @returns {{bin: *, cardNumber: *, cvvMaxLength: (*|module.exports.code|{hidden, default, type}), issuingNetwork: (*|string), isValid: *, isPotentiallyValid: *}}
 */
export default function getCardInfo(cardNumber) {
  const bin = cardNumber && cardNumber.replace(notANumberRegExp, '').slice(0, 6);

  const cardNumberWithoutSpaces = cardNumber.replace(/\s/, '');

  const hasNotOnlyDigit = notANumberRegExp.test(cardNumberWithoutSpaces);

  const { card, isValid, isPotentiallyValid } = cardValidator.number(
    hasNotOnlyDigit ? bin : cardNumberWithoutSpaces
  );

  const issuingNetwork = (card && card.type.replace(/\W/, '')) || 'default';
  const cardCode = card && card.code;
  const cvvMaxLength = cardCode && cardCode.size;

  return {
    bin,
    cardNumber,
    cvvMaxLength,
    issuingNetwork,
    isValid,
    isPotentiallyValid,
  };
}
